import { render } from "./BaseTableInspections.vue?vue&type=template&id=99beddde&scoped=true"
import script from "./BaseTableInspections.vue?vue&type=script&lang=js"
export * from "./BaseTableInspections.vue?vue&type=script&lang=js"

import "./BaseTableInspections.vue?vue&type=style&index=0&id=99beddde&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99beddde"]])

export default __exports__